import { Injectable } from '@angular/core';

const STORAGE_KEY = 'auth_tokens';

export interface PersistedAuthTokens {
  accessToken: string;
  idToken: string;
  refreshToken: string | null;
  /** Unix timestamp in seconds — same as JWT exp claim. */
  tokenExpiresAt: number;
}

@Injectable({ providedIn: 'root' })
export class MarketplaceTokenPersistenceService {

  save(tokens: PersistedAuthTokens): void {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(tokens));
    } catch {
      console.warn('[MarketplaceAuth] Failed to persist tokens to localStorage');
    }
  }

  load(): PersistedAuthTokens | null {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? (JSON.parse(raw) as PersistedAuthTokens) : null;
    } catch {
      return null;
    }
  }

  clear(): void {
    localStorage.removeItem(STORAGE_KEY);
  }
}
